<template>
  <div>
    <notifications />

    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Welcome!</h1>
              <p class="text-lead text-white">Inventory And Service Management Application</p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Sign In With Credentials</small>
              </div>
              <el-form
                role="form"
                @submit.prevent.native="signIn">
                <base-input
                  v-model="model.email"
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-email-83"
                  placeholder="Email"
                />

                <base-input
                  v-model="model.password"
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-lock-circle-open"
                  type="password"
                  placeholder="Password"
                />

                <div class="text-center">
                  <base-button
                    type="primary"
                    class="my-4"
                    native-type="submit">Sign in</base-button>
                </div>
              </el-form>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <router-link
                to="/forgotPassword"
                class="text-light">
                <small>Forgot password?</small>
              </router-link>
            </div>
            <div class="col-6 text-right">
              <router-link
                to="/register-request"
                class="text-light">
                <small>Add New Service Request</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Form } from "element-ui";
export default {
  components: {
    [Form.name]: Form
  },
  data() {
    return {
      model: {
        email: "",
        password: "",
        rememberMe: false
      }
    };
  },

  methods: {
    ...mapActions({
      login: "user/login"
    }),
    signIn() {
      this.login(this.model).then(res => {
        if (res === true) {
          this.$notify({
            message: "Logged In Successfully",
            type: "success",
            timeout: 5000,
            icon: "ni ni-bell-55",
            title: "Success"
          });
          this.$router.push("/alternative");
        } else {
          this.$notify({
            message: "Wrong Credential! Please Try Again!",
            type: "danger",
            timeout: 5000,
            icon: "ni ni-bell-55",
            title: "Error"
          });
        }
      });
    }
  }
};
</script>
